import { createSlice } from "@reduxjs/toolkit";

const intialAddLeadsState = {
  addleadsLoader: false,
  addLeadsData: {},
  addLeadsDataCount: 0,
  leadsList: {},
  leadDeletedData: {},
  resendInvitationDetails: {},
  sendInvitationListLoader: false,
  fetchSurveyQuestionsDetails: {},
  fetchSubmitSurveyDataResponse: {},
  surveyLoader: false,
  surveySubmissionsDetails: {},
};

const addLeads = createSlice({
  name: "addLeadsDetails",
  initialState: intialAddLeadsState,
  reducers: {
    getLeadsData: (state, action) => {
      state.addleadsLoader = true;
      console.log("addLeadsData slice", action.payload);
    },
    fetchLeadsList: (state, action) => {
      console.log("fetchAddLeadsData slice", action.payload);
      state.addleadsLoader = false;
      state.leadsList = action.payload;
      state.addLeadsDataCount = action.payload?.count;
    },
    addLeadsData: (state, action) => {
      state.addleadsLoader = true;
      console.log("addLeadsData slice", action.payload);
    },
    fetchAddLeadsData: (state, action) => {
      console.log("fetchAddLeadsData slice", action.payload);
      state.addleadsLoader = false;
      state.addLeadsData = action.payload;
    },
    deleteLeadsData: (state, action) => {
      state.addleadsLoader = true;
      console.log("addLeadsData slice", action.payload);
    },
    fetchDeletedLeadsData: (state, action) => {
      console.log("fetchAddLeadsData slice", action.payload);
      state.addleadsLoader = false;
      state.leadDeletedData = action.payload;
    },
    clearData: (state, action) => {
      console.log("Clear data");
      state.addleadsLoader = false;
      state.addLeadsData = {};
      state.leadDeletedData = {};
    },
    resendInvitationDetails: (state, action) => {
      state.sendInvitationListLoader = true;
    },
    setResendInvitationDetails(state, action) {
      state.resendInvitationDetails = action?.payload;
      state.sendInvitationListLoader = false;
    },
    fetchSurveyQuestions: (state, action) => {
      state.surveyLoader = true;
    },
    setFetchSurveyQuestionsDetails(state, action) {
      state.fetchSurveyQuestionsDetails = action?.payload;
      state.surveyLoader = false;
    },
    fetchSurveySubmissions: (state, action) => {
      state.surveyLoader = true;
    },
    setFetchSurveySubmissionsDetails(state, action) {
      state.surveySubmissionsDetails = action?.payload;
      state.surveyLoader = false;
    },
    submitSurveyData: (state, action) => {
      state.surveyLoader = true;
    },
    fetchSubmitSurveyDataResponse: (state, action) => {
      state.fetchSubmitSurveyDataResponse = action?.payload;
      state.surveyLoader = false;
    },
  },
});
export const addLeadsAction = addLeads.actions;
export default addLeads.reducer;
